module.exports = __webpack_public_path__ + "static/media/206_SHOT_358.565805dc.webp";